module.exports = __webpack_public_path__ + "img/Products_Desktop_06.034edd73.jpg";